import React from 'react';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import TabOfDataTable from '../Elements/DataTable/TabOfDataTable';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import ShownOverWindowsEnum from '../Enums/ShownOverWindowsEnum';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import dateTimeHelper from '../Helpers/datetimeHelper';
import JsxHelper from '../Helpers/JsxHelper';
import urlHelper from '../Helpers/urlHelper';
import VExportPaymentBaseTotalsService from '../Services/VExportPaymentBaseTotalsService';
import VExportPaymentBaseTotalItem from './VExportPaymentBaseTotalItem';

export default class PaymentExportAllExportItem {
  constructor(item) {
    if (item !== undefined) {
      this.initialize(item);
    }
  }

  async initialize(item) {
    this.XpId = item.xpId;

    this.CreatedBy = item.createdBy;
    this.CreatedByName = item.createdByName;
    this.CreatedOn = item.createdOn;
    this.DdpRejectSurcharge = item.ddprejectSurcharge;
    this.FirstCheck = item.firstCheck;
    this.LastCheck = item.lastCheck;
    this.officeName = item.officeName;

    this.NumberOfChecks = item.numberOfChecks;
    this.NumPayments = item.numPayments;
    this.NumPendingPayments = item.numPendingPayments;
    this.NumReconciliedPayments = item.numReconciliedPayments;
    this.NumVoidPayments = item.numVoidPayments;

    this.OfficeName = item.officeName;
    this.Print_DT = item.print_DT;

    this.XpCheckExpenses = item.xpCheckMisc + item.xpCheckTravel + item.xpCheckReimb + item.xpCheckGaming;
    this.XpCheckFee = item.xpCheckFee;
    this.XpCheckFeeAdjustment = item.xpCheckFeeAdjustment;
    this.XpCheckFeeBase = item.xpCheckFeeBase;
    this.XpCheckGaming = item.xpCheckGaming;
    this.XpCheckMisc = item.xpCheckMisc;
    this.XpCheckPaid = item.xpCheckPaid;
    this.XpCheckPaymentCount = item.xpCheckPaymentCount;
    this.XpCheckReimb = item.xpCheckReimb;
    this.XpCheckTotal = item.xpCheckTotal;
    this.XpCheckTravel = item.xpCheckTravel;
    this.XpCheckVat = item.xpCheckVat;

    this.XpDdpExpenses = item.xpDdpmisc + item.xpDdptravel + item.xpDdpreimb + item.xpDdpgaming;
    this.XpDdpfee = item.xpDdpfee;
    this.XpDdpfeeAdjustment = item.xpDdpfeeAdjustment;
    this.XpDdpfeeBase = item.xpDdpfeeBase;
    this.XpDdpgaming = item.xpDdpgaming;
    this.XpDdpMisc = item.xpDdpmisc;
    this.XpDdpPaid = item.xpDdppaid;
    this.XpDdppaymentCount = item.xpDdppaymentCount;
    this.XpDdpreimb = item.xpDdpreimb;
    this.XpDdptotal = item.xpDdptotal;
    this.XpDdptravel = item.xpDdptravel;
    this.XpDdpvat = item.xpDdpvat;

    // this.XpEmail=item.xpEmail;
    // this.XpEmailChecks=item.xpEmailChecks;
    this.XpEmailChecksDate = item.xpEmailChecksDate;
    this.XpEmailDt = item.xpEmailDt;
    this.XpGenDate = item.xpGenDate;

    this.XpIntlExpenses = item.xpIntlMisc + item.xpIntlTravel + item.xpIntlReimb + item.xpIntlGaming;
    this.XpIntlFee = item.xpIntlFee;
    this.XpIntlFeeAdjustment = item.xpIntlFeeAdjustment;
    this.XpIntlFeeBase = item.xpIntlFeeBase;
    this.XpIntlGaming = item.xpIntlGaming;
    this.XpIntlMisc = item.xpIntlMisc;
    this.XpIntlPaid = item.xpIntlPaid;
    this.XpIntlPaymentCount = item.xpIntlPaymentCount;
    this.XpIntlReimb = item.xpIntlReimb;
    this.XpIntlTotal = item.xpIntlTotal;
    this.XpIntlTravel = item.xpIntlTravel;
    this.XpIntlVat = item.xpIntlVat;

    this.XpIsFinished = item.xpIsFinished;
    this.XpLdvid = item.xpLdvid;
    this.XpLdvName = item.xpLdvname;
    this.XpManual = item.xpManual;
    // this.XpPrint=item.xpPrint;
    this.XpPrintDt = item.xpPrintDt;
    this.XpProcFee = item.xpProcFee;
    this.XpRcyCode = item.xpRcycode;
    this.XpRcyid = item.xpRcyid;
    this.XpRcyName = item.xpRcyName;
    this.XpRcySymbol = item.xpRcySymbol;
    this.XpYrmo = item.xpYrmo;
  }

  static NameOfTheIdField() {
    return 'XpId';
  }
  static nameOfTheItemDetailList() {
    return 'Export';
  }

  static MoneyFields = [
    'XpCheckFeeBase',
    'XpCheckReimb',
    'XpCheckGaming',
    'XpCheckFeeAdjustment',
    'XpCheckMisc',
    'XpCheckExpenses',
    'XpCheckFee',
    'XpCheckTravel',
    'XpCheckVat',
    'XpCheckTotal',
    'XpCheckPaid',
    'XpIntlFeeBase',
    'XpIntlReimb',
    'XpIntlGaming',
    'XpIntlFeeAdjustment',
    'XpIntlMisc',
    'XpIntlExpenses',
    'XpIntlFee',
    'XpIntlTravel',
    'XpIntlVat',
    'XpIntlTotal',
    'XpIntlPaid',
    'XpDdpfeeBase',
    'XpDdpreimb',
    'XpDdpgaming',
    'XpDdpfeeAdjustment',
    'XpDdpMisc',
    'XpDdpExpenses',
    'XpDdpfee',
    'XpDdptravel',
    'XpDdpvat',
    'XpDdptotal',
    'XpDdpPaid',
    'XpProcFee',
  ];

  static Currency() {
    return 'XpRcyCode';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = ['Print_DT', 'XpGenDate', 'XpPrintDt'];

  static BoolFields = [];

  static FieldsToShowInListTable = [
    {
      tabName: 'Info',
      tabLabel: 'Info',
      icon: 'fa-solid fa-info',
      data: [
        { name: 'OfficeName', label: 'Office', className: 'text-left' },
        { name: 'XpYrmo', label: 'YRMO' },
        { name: (item) => dateTimeHelper.toYYYYsMMsDDsHHsMM(item.XpGenDate), label: 'Exported On' },
        { name: (item) => dateTimeHelper.toYYYYsMMsDDsHHsMM(item.XpEmailDt), label: 'Emailed On' },
        {
          name: (item) => dateTimeHelper.toYYYYsMMsDDsHHsMM(item.XpPrintDt),
          label: 'Printed On',
          className: 'text-left',
        },
        { name: (item) => dateTimeHelper.toYYYYsMMsDDsHHsMM(item.XpEmailChecksDate), label: 'Checks Emailed On' },
        { name: (item) => JsxHelper.YesNo(item.XpManual === 'Y'), label: 'Manual' },
        { name: 'XpRcyCode', label: 'Code', className: 'text-left' },
        { name: '-', label: '-' },
        { name: 'XpCheckFee', label: 'Check Fee' },
        { name: 'XpDdpfee', label: 'DDP Fee' },
        { name: 'XpIntlFee', label: 'International Fee' },
        { name: 'XpCheckReimb', label: 'Check Reimbursement' },
        { name: 'XpDdpreimb', label: 'DDP Reimbursement' },
        { name: 'XpIntlReimb', label: 'International Reimbursement' },
        { name: 'XpCheckPaid', label: 'Check Paid' },
        { name: 'XpDdpPaid', label: 'DDP Paid' },
        { name: 'XpIntlPaid', label: 'International Paid' },
        { name: 'XpProcFee', label: 'Processing Fee' },
      ],
    },
    {
      tabName: 'Totals1',
      tabLabel: 'Total - Detailed',
      icon: 'fa-solid fa-sigma',
      data: [
        { name: PaymentExportAllExportItem.GetTotalsContent, label: '', width: TabListTableCellWidthEnum.TwoLines },
      ],
    },
    {
      tabName: 'Totals2',
      tabLabel: 'Total - Summary',
      icon: 'fa-solid fa-sigma',
      data: [
        { name: '-', label: 'International' },
        { name: 'XpIntlPaymentCount', label: 'Payment Count' },
        { name: '', label: '', className: 'text-left' },
        { name: '', label: '', className: 'text-left' },
        { name: 'XpIntlFeeBase', label: 'Eval Fee' },
        { name: 'XpIntlReimb', label: 'Eval Reimbursement' },
        { name: 'XpIntlGaming', label: 'Eval Gaming' },
        { name: 'XpIntlFeeAdjustment', label: 'Additional Eval Fee' },
        { name: 'XpIntlMisc', label: 'Eval Special Reimbursement' },
        { name: 'XpIntlExpenses', label: 'Subtotal of Expenses' },
        { name: 'XpIntlFee', label: 'Subtotal of Fees' },
        { name: 'XpIntlTravel', label: 'Eval Travel' },
        { name: 'XpIntlVat', label: 'VAT' },
        { name: 'XpIntlTotal', label: 'International Total' },
        { name: 'XpIntlPaid', label: 'International Paid' },

        { name: '-', label: 'Checks' },
        { name: 'XpCheckPaymentCount', label: 'Payment Count' },
        { name: '', label: '', className: 'text-left' },
        { name: '', label: '', className: 'text-left' },
        { name: 'XpCheckFeeBase', label: 'Check Fee' },
        { name: 'XpCheckReimb', label: 'Check Reimb' },
        { name: 'XpCheckGaming', label: 'Eval Gaming' },
        { name: 'XpCheckFeeAdjustment', label: 'Additional Eval Fee' },
        { name: 'XpCheckMisc', label: 'Eval Special Reimbursement' },
        { name: 'XpCheckExpenses', label: 'Subtotal of Expenses' },
        { name: 'XpCheckFee', label: 'Subtotal of Fees' },
        { name: 'XpCheckTravel', label: 'Eval Travel' },
        { name: 'XpCheckVat', label: 'VAT' },
        { name: 'XpCheckTotal', label: 'Check Total' },
        { name: 'XpCheckPaid', label: 'Check Paid' },

        { name: '-', label: 'DDP' },
        { name: 'XpDdppaymentCount', label: 'Payment Count', className: 'text-center' },
        { name: '', label: '', className: 'text-left' },
        { name: '', label: '', className: 'text-left' },
        { name: 'XpDdpfeeBase', label: 'DDP Fee' },
        { name: 'XpDdpreimb', label: 'DDP Reimb' },
        { name: 'XpDdpgaming', label: 'Eval Gaming' },
        { name: 'XpDdpfeeAdjustment', label: 'Additional Eval Fee' },
        { name: 'XpDdpMisc', label: 'Eval Special Reimbursement' },
        { name: 'XpDdpExpenses', label: 'Subtotal of Expenses' },
        { name: 'XpDdpfee', label: 'Subtotal of Fees' },
        { name: 'XpDdptravel', label: 'Eval Travel' },
        { name: 'XpDdpvat', label: 'VAT' },
        { name: 'XpDdptotal', label: 'DDP Total' },
        { name: 'XpDdpPaid', label: 'Ddp Paid' },
        { name: '-', label: '' },
        { name: 'XpProcFee', label: 'Processing Fee' },
      ],
    },
  ];

  //Meaning of data field:
  //   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field
  //   if type is FieldTypesEnum.PureDataField then it is the name of the field to show or it is a function
  //			and the field shows the result of this function
  //   if type is FieldTypesEnum.FunctionField then it is the function which will be called by clicking on the labeltext in the cell.
  static FieldsToShowInDataTable() {
    return [
      { label: 'Export Id', orderById: 'XpId', data: PaymentExportAllExportItem.GetDetailCellContent, minWidth: 50 },
      { label: 'Payment Office', orderById: 'OfficeName', data: 'OfficeName', minWidth: 50 },
      { label: 'Yrmo', orderById: 'XpYrmo', data: 'XpYrmo', minWidth: 50 },
      { label: '# Payments', orderById: '', data: 'NumPayments', minWidth: 50, className: 'text-left' },
      { label: '# Reconcilied', orderById: '', data: 'NumReconciliedPayments', minWidth: 50, className: 'text-left' },
      { label: '# Void', orderById: '', data: 'NumVoidPayments', minWidth: 50, className: 'text-left' },
      { label: '# Pending Recon', orderById: '', data: 'NumPendingPayments', minWidth: 50, className: 'text-left' },
      {
        label: 'Exported On',
        orderById: 'XpGenDate',
        data: (item) => dateTimeHelper.toYYYYsMMsDDsHHsMM(item.XpGenDate),
        minWidth: 50,
      },
      {
        label: 'Printed On',
        orderById: '',
        data: (item) => dateTimeHelper.toYYYYsMMsDDsHHsMM(item.XpPrintDt),
        minWidth: 50,
      },
      { label: 'Manual', orderById: 'Manual', data: (item) => JsxHelper.OnlyYes(item.XpManual === 'Y'), minWidth: 50 },
      {
        label: ' ',
        orderById: '',
        data: PaymentExportAllExportItem.GetActionCellContent,
        type: FieldTypesEnum.ActionButton,
        minWidth: 50,
      },
    ];
  }

  static GetDetailCellContent(item) {
    return urlHelper.getIconLinkComponent(
      item.XpId,
      'fa-solid fa-arrow-up-right-from-square',
      'text-primary pl-1 pr-1',
      'paymentexportdetails',
      `id=${item.XpId}`,
      'Open up in a new tab'
    );
  }

  static GetActionCellContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            text: 'Create PDF',
            onClick: () => PaymentExportAllExportItem.clickOnPdf(item),
            iconName: 'fa-solid fa-file-pdf',
            disabled: item.NumberOfChecks === 0,
            roleKey: 'ExportPaymentActionButtons',
          },
        ]}
      />
    );
  }

  static clickOnPdf(item) {
    //This is a placeholder, don't remove it!
  }

  static GetTotalsContent(item) {
    return (
      <TabOfDataTable
        type={VExportPaymentBaseTotalItem}
        shownPanel={ShownOverWindowsEnum.None}
        serviceFunction={VExportPaymentBaseTotalsService.GetListByExportId}
        searchItem={{ exportId: item.XpId }}
        convertDBItemsFunction={VExportPaymentBaseTotalsService.ConvertDBItems}
        redirectLinkOnInfo={urlHelper.generateLeadSearchRedirectUrl(
          'assignments',
          'AsBillClient=&AsPayEvaluator=&AsSassieAsgnId',
          ''
        )}
        errorCode='PEAEI302'
      />
    );
  }
}
